export const ROUTES = {
    HOME: '/',
    ABOUT: '/about',
    PROJECTS: {
        ROOT: '/projects',
        DETAILS: '/projects/:projectId',
        MAYLEO: '/projects/mayleo',
        FERTENERGIE: '/projects/fertenergie',
        ENERGETICIENNE: '/projects/energeticienne',
        PORTFOLIO: '/projects/portfolio',
        ALTAIR: '/projects/altair',
    },
} as const;
